import React from 'react'
import { Helmet } from 'react-helmet'
import {Link, Redirect} from 'react-router-dom'
import HeaderTopImage from './HeaderTopImage'
import Footer from '../Footer/Footer';


export default class Policy extends React.Component {
	render() {
		return (
			<>
      <Helmet>
        <title>Policy
 - Grospick </title>
        <meta name="description" content="Grospick is a delivery company with a personal touch offering a huge range of services and locations. Grospick delivers anything from bread to fruits or even groceries, door to door and on-demand." />
        <meta property="og:title" content="Policy - Grospick" />
        <meta property="og:image" content="https://res.cloudinary.com/mhmd/image/upload/v1556834139/img-1_e25nvh.jpg" />
        <meta property="og:image:secure_url" content="https://res.cloudinary.com/mhmd/image/upload/v1556834139/img-1_e25nvh.jpg" />
        <meta property="og:description" content="Grospick is a delivery company with a personal touch offering a huge range of services and locations. Grospick delivers anything from bread to fruits or even groceries, door to door and on-demand." />
        <meta property="og:url" content={`https://www.grospick.com/policy`} />
        <meta property="og:site_name" content="Grospick" />
        <link rel="canonical" href="https://www.grospick.com/policy" />
        <meta name="twitter:card" content="Grospick policy" />
        <meta name="twitter:description" content="Grospick is a delivery company with a personal touch offering a huge range of services and locations. Grospick delivers anything from bread to fruits or even groceries, door to door and on-demand." />
        <meta name="twitter:title" content="Policy - Grospick" />
        <meta name="twitter:image" content="https://res.cloudinary.com/mhmd/image/upload/v1556834139/img-1_e25nvh.jpg" />
                    </Helmet>
			
			<HeaderTopImage titre="Policy" destination="Home" />
		<div>
<div className="bg-light" style={{marginBottom:'0px'}}>
  <div className="container" style={{marginBottom:'0px'}}>
    <div className="row h-100 align-items-center py-5">
      <div className="col-lg-12">
        <h4 className="h4">Overview <i className="fa fa-podcast fa-1x" style={{color:'#34918c99'}}></i></h4>
        <p className="lead text-dark mb-0" style={{textAlign:'justify'}}>
        This privacy policy has been compiled to better serve those who are concerned with how their personal information is being used online. Personal information is data that can be used on its own or with other information to identify, contact, or locate a single person, or to identify an individual in context. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website.
        <br /></p>
      </div>
    </div>
  </div>
</div>

<div className="bg-white" style={{marginBottom:'0px', textAlign:'left'}}>
  <div className="container" style={{marginBottom:'0px'}}>
    <div className="row h-100 align-items-center py-4">
      <div className="col-lg-12">
        <h4 className="h4">What do we collect? </h4>
        <p className="lead text-dark mb-0" style={{textAlign:'justify'}}>
When ordering or registering on our site, as appropriate, you may be asked to enter your name, email address, mailing address, phone number, credit card information or other details to help you with your experience.
<br />
</p>
<br />
<h4 className="h4" style={{textAlign:'left'}}>When do we collect information? </h4>
<p className="lead text-dark mb-0" style={{textAlign:'justify'}}>
We collect information from you when you place an order, subscribe to a newsletter, fill out a form or enter information on our site.
</p>
<br />
<h4 className="h4" style={{textAlign:'left'}}>How do we use information? </h4>
<p className="lead text-dark mb-0" style={{textAlign:'justify'}}>
We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:
<br/>
• To personalize your experience and to allow us to deliver the type of content and offerings in which you are most interested.
<br/><br/>• To improve our website in order to better serve you.
<br/><br/>• To allow us to better service you in responding to your customer service requests.
<br/><br/>• To quickly process your transactions.
<br/><br/>• To send periodic emails regarding your order or other products and services.
<br/><br/>• To follow up with you after correspondence.
</p>
<br />

<h4 className="h4" style={{textAlign:'left'}}>How do we protect information? </h4>
<p className="lead text-dark mb-0" style={{textAlign:'justify'}}>
Our website is checked on a regular basis for security holes and known vulnerabilities in order to make your visit to our site as safe as possible. Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (SSL) technology.
<br /><br />
We implement a variety of security measures when a user places an order enters, submits, or accesses their information to maintain the safety of your personal information.
All transactions are processed through a gateway provider and are not stored or processed on our servers.
</p>
<br />
<h4 className="h4" style={{textAlign:'left'}}>Do we use cookies? </h4>
<p className="lead text-dark mb-0" style={{textAlign:'justify'}}>
Yes. Cookies are small files that a site or its service provider transfers to your computer’s hard drive through your Web browser (if you allow) that enables the site’s or service provider’s systems to recognize your browser and capture and remember certain information. For instance, we use cookies to help us remember and process the items in your shopping cart. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.
<br />
We use cookies to:
<br />
Help remember and process the items in the shopping cart.
<br />
Understand and save user’s preferences for future visits.
<br />
Keep track of advertisements.
<br />
Compile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. We may also use trusted third-party services that track this information on our behalf (for example, Google Analytics).
<br />
You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since browser is a little different, look at your browser’s Help Menu to learn the correct way to modify your cookies.
<br /><br />
If you turn cookies off, Some of the features that make your site experience more efficient may not function properly. It won’t affect the user’s experience that make your site experience more efficient and may not function properly.
</p>
<br />

<h4 className="h4" style={{textAlign:'left'}}>Third-party disclosure </h4>
<p className="lead text-dark mb-0" style={{textAlign:'justify'}}>
We do not sell, trade, or otherwise transfer to outside parties your personal information. This does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when its release is appropriate to comply with the law, enforce our site policies, or protect ours or others’ rights, property or safety.
<br /> <br />
Non-personally identifiable visitor information may be provided to other parties for marketing, advertising, or other uses. We do not include or offer third-party products or services on our website.
</p>
<br />

<h4 className="h4" style={{textAlign:'left'}}>CAN-SPAM Act </h4>
<p className="lead text-dark mb-0" style={{textAlign:'justify'}}>
The CAN-SPAM Act is a law that sets the rules for commercial email, establishes requirements for commercial messages, gives recipients the right to have emails stopped from being sent to them, and spells out tough penalties for violations.
<br /> <br/>
<b>We collect your email address in order to:
</b>
<br/>
Send information, respond to inquiries, and/or other requests or questions

Process orders and to send information and updates pertaining to orders.

Send you additional information related to your product and/or service

Market to our mailing list or continue to send emails to our clients.
</p>
<br />

<h4 className="h4" style={{textAlign:'left'}}>Prohibited Uses </h4>
<p className="lead text-dark mb-0" style={{textAlign:'justify'}}>
In addition to other prohibitions as set forth in the Terms of Service, you are prohibited from using the site or its content: (a) for any unlawful purpose; (b) to solicit others to perform or participate in any unlawful acts; (c) to violate any international, federal, provincial or state regulations, rules, laws, or local ordinances; (d) to infringe upon or violate our intellectual property rights or the intellectual property rights of others; (e) to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability; (f) to submit false or misleading information; (g) to upload or transmit viruses or any other type of malicious code that will or may be used in any way that will affect the functionality or operation of the Service or of any related website, other websites, or the Internet; (h) to collect or track the personal information of others; (i) to spam, phish, pharm, pretext, spider, crawl, or scrape; (j) for any obscene or immoral purpose; or (k) to interfere with or circumvent the security features of the Service or any related website, other websites, or the Internet. We reserve the right to terminate your use of the Service or any related website for violating any of the prohibited uses.
</p>
<br />

<h4 className="h4" style={{textAlign:'left'}}>To be in accordance with CANSPAM, we agree to the following: </h4>
<p className="lead text-dark mb-0" style={{textAlign:'justify'}}>
 Not use false or misleading subjects or email addresses.
<br />
Identify the message as an advertisement in some reasonable way.
<br />
Include the physical address of our business or site headquarters.
<br />
Monitor third-party email marketing services for compliance.
<br />
Honor opt-out/unsubscribe requests quickly.
<br />
Allow users to unsubscribe by using the link at the bottom of each email.
<br />
<br />
If at any time you would like to unsubscribe from receiving future emails, you can do so by following the instructions at the bottom of each email.
</p>
<br />

<h4 className="h4">Information or suggestions: </h4>
<p className="lead text-dark mb-0" style={{textAlign:'justify'}}>
For any additional information or suggestions on how the site works, please do not hesitate to contact us. 
<footer class="blockquote-footer">  Don't step out, just <cite title="Source Title">Grospick it</cite></footer></p>
<br />
<Link to="./contact" style={{textDecoration:'none', color:'#34918c'}}><a className="btn btn-light px-5 rounded-pill shadow-sm">Contact-us</a></Link>
      </div>
    </div>
    <div className="col-lg-5 px-5 mx-auto order-1 order-lg-2"><img src="https://res.cloudinary.com/mhmd/image/upload/v1556834139/img-1_e25nvh.jpg" alt="" className="img-fluid mb-4 mb-lg-0" /></div>
  </div>
</div>
</div>
 <br /> <br />
        	<Footer />
			</>
		)
	}
}